import React from "react";
import { injectIntl } from "react-intl";
import { TranslateText } from '../TranslateText';
import { jsx as _jsx } from "react/jsx-runtime";
const _HintMessage = ({
  hintMessage
}) => {
  return /*#__PURE__*/_jsx("div", {
    className: "refresh",
    children: /*#__PURE__*/_jsx(TranslateText, {
      id: hintMessage
    })
  });
};
export const HintMessage = injectIntl( /*#__PURE__*/React.memo(_HintMessage));